import {useNavigate} from 'react-router';

import {createDataTableConfig} from '@/lib/helpers/config';

import {DataTable} from '@/components/dataTable';

import {useProduct} from '../providers/productProvider';

const ProductDetailsPositionLog = () => {
  const navigate = useNavigate();
  const {product} = useProduct();

  // Data Table Config
  const dataTableConfig = createDataTableConfig({
    table: 'Position',
    title: 'Position Log',
    columns: ['position_status', 'fk_product_id', 'position_id', ['Market', ['market_name']]],
    searchColumn: 'fk_product_id',
    filters: [
      {column: 'fk_product_id', operator: 'eq', value: product?.product_id ?? 0},
      {column: 'position_status', operator: 'neq', value: 'pending'},
    ],
    addButtonLabel: 'Add Position',
    noResultsMessage: 'No positions associated with product',
    preventScrolling: true,
    columnsDisplay: [
      {
        header: 'Market',
        field: 'Market.market_name',
      },

      {
        header: 'Date Created',
        field: 'date_created',
      },
    ],
    actionsDisplay: [
      {
        icon: 'ri-eye-line',
        color: 'primary',
        handler: async row => {
          navigate(`/position/${row.position_id}`);
        },
        permission: () => true,
      },
    ],
  });

  return <DataTable {...dataTableConfig} />;
};

export default ProductDetailsPositionLog;
